import { useAuthStore } from '@auth/authStore'
import { getSites, getAssets } from '@entities'
import { useAsyncResource } from './useAsyncResource'

function requireId (value, field) {
  if (value === null || value === undefined || String(value).trim() === '') {
    throw new Error(`Location data is missing ${field}.`)
  }

  return String(value)
}

export function useScopeOptions () {
  const companyId = useAuthStore(state => state.companyID)

  const resource = useAsyncResource(
    async () => {
      const [sites, assets] = await Promise.all([
        getSites(companyId),
        getAssets(companyId)
      ])

      if (!Array.isArray(sites) || !Array.isArray(assets)) {
        throw new Error('The site and asset APIs must return lists.')
      }

      return {
        companyId,
        sites: sites.map(row => {
          const id = requireId(row?.site_id, 'site_id')

          return {
            id,
            label: String(row.WindFarm || id)
          }
        }),
        assets: assets.map(row => {
          const id = requireId(row?.asset_id, 'asset_id')
          const siteId = requireId(row?.site_id, 'site_id')

          return {
            id,
            siteId,
            key: JSON.stringify([siteId, id]),
            label: String(row.Asset || id)
          }
        })
      }
    },
    [companyId],
    {
      initialData: null,
      enabled: Boolean(companyId)
    }
  )

  const data = resource.data?.companyId === companyId ? resource.data : null

  return {
    companyId,
    sites: data?.sites ?? [],
    assets: data?.assets ?? [],
    isLoading:
      Boolean(companyId) && (resource.isLoading || (!data && !resource.error)),
    error: companyId ? resource.error : null,
    reload: resource.reload
  }
}
